import { render, staticRenderFns } from "./ZoneEdit.vue?vue&type=template&id=23c8545b"
import script from "./ZoneEdit.vue?vue&type=script&lang=js"
export * from "./ZoneEdit.vue?vue&type=script&lang=js"
import style0 from "./ZoneEdit.vue?vue&type=style&index=0&id=23c8545b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports